import AppRecord from './AppRecord.js'

class InvoiceTypeIntervalLine extends AppRecord {
  get controller_name(){
    return 'InvoiceTypeIntervalLinesController'
  }

  get formatted_rate(){
    if (this.invoice_source && this.invoice_source == 'once'){
      return this.rate
    } else {
      return (this.rate * 100).round(10)
    }
  }

  set formatted_rate(value){
    if (this.invoice_source && this.invoice_source == 'once'){
      this.rate = value
    } else {
      this.rate = value != 0 ? value /100 : 0
    }
  }  
}

export default InvoiceTypeIntervalLine
